import { writable } from '../../_snowpack/pkg/svelte/store.js';

/**
 * URLパラメータ
 */
export const inputValues = writable({});

/**
 * SearchControlPanelで指定された値
 */
export const currentParams = writable();

/**
 * コンポーネントタグのDataSetに渡された初期値
 */
export const defaultParams = writable({});

/**
 * パラメータの入ったオブジェクトを受け取って、現在のパラメータStoreを更新する
 *
 * @param object values store object
 */
export const setCurrentParams = (values) => {
	const currentValues = JSON.parse(JSON.stringify(values));
	currentParams.set(currentValues);
};

/**
 * パラメータの入ったオブジェクトを受け取って、URLを書き換える
 *
 * @param object valuesObject パラメータ
 */
export const setURLParams = (valuesObject) => {
	let url = new URLSearchParams();
	Object.keys(valuesObject).forEach((k) => {
		if (valuesObject[k] && !('none' === valuesObject[k])) {
			url.set(k, valuesObject[k]);
		}
	});
	const params = url.toString();
	history.replaceState('', '', '?' + params);
};

/**
 * URLからパラメータを受け取って、inputValues storeを更新する
 *
 * @return void
 */
export const getURLParams = (defaultValues = {}) => {
	let params = new URLSearchParams(window.location.search);
	let values = defaultValues;

	for (var key of params.keys()) {
		if (params.get(key)) {
			values[key] = params.get(key);
		}
	}

	inputValues.set(values);
};
